import Select from './Select';
import Option from './Option';
import { SelectPropTypes } from './PropTypes';
import OptGroup from './OptGroup';
Select.Option = Option;
Select.OptGroup = OptGroup;
export { Option, OptGroup, SelectPropTypes };
export default Select;


//////////////////
// WEBPACK FOOTER
// ./~/rc-select/es/index.js
// module id = 1122
// module chunks = 0